import { render } from "./RecopilarDatosPN2Respuestas.vue?vue&type=template&id=3c8499e6&ts=true"
import script from "./RecopilarDatosPN2Respuestas.vue?vue&type=script&lang=ts"
export * from "./RecopilarDatosPN2Respuestas.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__